export default __webpack_public_path__ + "static/media/fi-info.6ce7b81d.svg";